const PushNotification = () =>
  import("@/views/pushNotification/PushNotifications");

export const pushNotificationsRoute = {
  path: "/pushNotifications",
  component: PushNotification,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",    
    breadcrumb: [
      {
        text: "Notificaciones",
        disabled: false,
        href: "#"
      }
    ],
    scope:["aps_admin"]
  }
};

const PushNotificationsCreate = () =>
  import("@/views/pushNotification/PushNotificationsCreate");

export const pushNotificationsCreateRoute = {
  path: "/createPushNotification",
  component: PushNotificationsCreate,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",
    backState: "pushNotifications",
    breadcrumb: [
      {
        text: "Notificaciones",
        disabled: false,
        href: "pushNotifications"
      },
      {
        text: "Crear",
        disabled: false,
        href: "#"
      }
    ],
    scope:["aps_admin"]
  }
};